import React from 'react';
import { faFlagCheckered } from '@fortawesome/pro-solid-svg-icons/faFlagCheckered';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FlagCheckeredSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faFlagCheckered} {...props} />;
}
